export default "__VITE_ASSET__2ae4674b__"